import { openDB } from "idb";

export const dbPromise = openDB("esgDB", 2, {
  upgrade(db) {
    const tabs = [
      "Esg_Coverage",
      "Fields_in_Package",
      "Field_Description",
      "Package_Endpoint_Mapping",
      "ESG_PLIs"
    ];
    for (const tab of tabs) {
      if (!db.objectStoreNames.contains(tab)) {
        db.createObjectStore(tab, { keyPath: "content" });
      }
    }
  },
});

export async function addItem(tab, items) {
  const db = await dbPromise;
  for(let item of items){
    db.put(tab, item)
  }
  return ;
}

export async function getAllItems(tab) {
  const db = await dbPromise;
  return db.getAll(tab);
}

export async function getItem(tab, id) {
  const db = await dbPromise;
  return db.get(tab, id);
}

export async function deleteItem(tab, id) {
  const db = await dbPromise;
  return db.delete(tab, id);
}

export async function clearStore(tab) {
  const db = await dbPromise;
  return db.clear(tab);
}

export async function clearAllStores() {
  const db = await dbPromise;
  const storeNames = db.objectStoreNames;
  for (const storeName of storeNames) {
    await db.clear(storeName);
  }
  return true;
}